import { booleanAttribute, ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { AbstractControl, ControlValueAccessor, ValidationErrors, Validator } from '@angular/forms';
import { BspkCheckbox } from '../checkbox';
import { noop, provideValidator, provideValueAccessor } from '../util';
import { BspkToggleOption } from '../toggle-option';

/**
 * A control that allows users to choose one or more items from a list or turn a feature on or off.
 */
@Component({
  selector: 'bspk-checkbox-option',
  imports: [BspkCheckbox, BspkToggleOption],
  templateUrl: './checkbox-option.component.html',
  styleUrl: './checkbox-option.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideValueAccessor(BspkCheckboxOption), provideValidator(BspkCheckboxOption)],
})
export class BspkCheckboxOption implements ControlValueAccessor, Validator {
  readonly label = input.required<string>();
  readonly description = input<string>();
  readonly checked = model<boolean | null>(false);
  readonly disabled = input(false, { transform: booleanAttribute });
  readonly readOnly = input(false, { transform: booleanAttribute });
  readonly required = input(false, { transform: booleanAttribute });
  readonly indeterminate = input(false, { transform: booleanAttribute });

  protected onChange: (value: any) => void = noop;
  protected onTouched: () => void = noop;

  protected handleChange(checked: boolean | null) {
    this.checked.set(checked);
    this.onChange(checked);
  }

  /**
   * @see ControlValueAccessor
   */
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  /**
   * @see ControlValueAccessor
   */
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  /**
   * @see ControlValueAccessor
   */
  setDisabledState(_isDisabled: boolean): void {
    // noop
  }

  /**
   * @see ControlValueAccessor
   */
  writeValue(obj: any): void {
    this.checked.set(!!obj);
  }

  /**
   * @see Validator
   */
  validate(_formControl: AbstractControl<boolean>): ValidationErrors | null {
    if (this.required() && !this.checked()) {
      return { required: true };
    }
    return null;
  }

  /**
   * @see Validator
   */
  registerOnValidatorChange(_fn: VoidFunction): void {
    // noop
  }
}
